var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopStreaming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 23,
    viewBox: "0 0 21 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97631 17.8845L0 21.5L1.15807 22.4533L4.82415 18H11.5492C12.4169 18 13.1589 17.6919 13.775 17.0758C14.3911 16.4596 14.6992 15.7177 14.6992 14.85V13.0344L19.107 17.4422C19.2383 17.5807 19.4023 17.65 19.5992 17.65C19.6867 17.65 19.7779 17.6318 19.8727 17.5953C20.157 17.4714 20.2992 17.2563 20.2992 16.95V5.05C20.2992 4.74375 20.157 4.52865 19.8727 4.40469C19.7779 4.36823 19.6867 4.35 19.5992 4.35C19.4023 4.35 19.2383 4.41927 19.107 4.55781L14.6992 8.95469V7.15C14.6992 6.80695 14.6511 6.48355 14.5548 6.17982L18.8573 0.953347L17.6992 0L13.7031 4.85426C13.1014 4.28475 12.3834 4 11.5492 4H3.84922C2.98151 4 2.23958 4.30807 1.62344 4.92422C1.00729 5.54036 0.69922 6.28229 0.69922 7.15V14.85C0.69922 15.7177 1.00729 16.4596 1.62344 17.0758C2.02181 17.4742 2.47277 17.7437 2.97631 17.8845ZM2.97631 17.8845C3.25157 17.9615 3.54254 18 3.84922 18H4.82415L14.5548 6.17982C14.4075 5.7153 14.1475 5.29677 13.775 4.92422C13.7512 4.90044 13.7273 4.87712 13.7031 4.85426L2.97631 17.8845Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopStreaming);
export default __webpack_public_path__ + "static/media/stopStreaming.d7a5e990d57108398185e82fc28d038a.svg";
export { ForwardRef as ReactComponent };